import React from "react";

const IdleContext = React.createContext();

export const IdleProvider = IdleContext.Provider;
export const IdleConsumer = IdleContext.Consumer;

export default IdleContext;
